import { request } from '../../../config/helpers/axios-instance';

/** Single backend route for caregiver ↔ patient: always `{ user, patient, relationship }`. */
export const USER_PATIENT_MAPPING_URL = 'userOrder/admin/addCaregiverAndPatient';

/**
 * Submit user + patient + relationship. The server creates users and/or mappings as needed
 * (new accounts, new mappings, or linking existing ids).
 *
 * @param {{ user: object, patient: object, relationship: string }} body
 */
export const submitUserPatientMapping = async (orderId, body) =>
    request({
        url: `${USER_PATIENT_MAPPING_URL}/${orderId}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
    });

/** @deprecated Use {@link submitUserPatientMapping} */
export const createUserPatientMapping = (body) => submitUserPatientMapping(body);

/** Extract new mapping id from typical API response shapes (e.g. to attach an order). */
export const getMappingIdFromCreateResponse = (res) =>
    res?.data?.data?.id ??
    res?.data?.data?.userMappingId ??
    res?.data?.data?.mapUserPatient?.id ??
    res?.data?.data?.mapUserPatientId ??
    res?.data?.id ??
    null;
